// Блоки меню с группировкой по разделам
export const MENU_BLOCKS = [
    {
        label: "Основное",
        items: [
            { label: "Отели", value: "hotels", icon: "hotel" },
            { label: "Компании", value: "companies", icon: "business" },
            { label: "Точки продаж", value: "places_sales", icon: "store" },
        ],
    },
    {
        label: "Управление доступом",
        items: [
            { label: "Пользователи", value: "users", icon: "people" },
            { label: "Журнал доступов", value: "access_logs", icon: "security" },
        ],
    },
    {
        label: "Настройки",
        items: [
            { label: "Конфигурация", value: "configurations", icon: "settings" },
            { label: "Способы оплаты", value: "payment_methods", icon: "payment" },
            { label: "Типы интерфейсов", value: "interface_types", icon: "api" },
            { label: "Интерфейсы", value: "interfaces", icon: "integration_instructions" },
        ],
    },
    {
        label: "Номера и тарифы",
        items: [
            { label: "Категории номеров", value: "room_types", icon: "meeting_room" },
            { label: "Квоты номеров", value: "room_quotas", icon: "dashboard" },
            { label: "Тарифы", value: "rates", icon: "attach_money" },
            { label: "Стоимость проживания", value: "room_rates", icon: "monetization_on" },
            { label: "Уровни цен", value: "price_periods", icon: "date_range" },
            { label: "Правила отмены", value: "cancellation_policy", icon: "cancel" },
            { label: "Возвраты ДС", value: "refund", icon: "money_off" },
        ],
    },
    {
        label: "Услуги и удобства",
        items: [
            { label: "Категории услуг", value: "service_categories", icon: "room_service" },
            { label: "Услуги", value: "services", icon: "concierge" },
            { label: "Категории удобств", value: "room_feature_categories", icon: "star" },
            { label: "Удобства", value: "room_features", icon: "star_border" },
        ],
    },
    {
        label: "Бронирования",
        items: [
            { label: "Заявки", value: "reservations", icon: "assignment" },
            { label: "Заявки АСУ", value: "reservations_asu", icon: "assignment_ind" },
            { label: "Запреты выезда", value: "banArrivals", icon: "block" },
            { label: "Срок проживания", value: "period_residence", icon: "event_available" },
            { label: "Толкование цен", value: "price_explanation", icon: "info" },
            { label: "Купленные услуги", value: "purchased_services", icon: "shopping_cart" },
        ],
    },
    {
        label: "Маркетинг",
        items: [
            { label: "Промокоды", value: "promo", icon: "local_offer" },
            { label: "Торговые группы", value: "market_groups", icon: "group_work" },
            { label: "Торговые коды", value: "market_codes", icon: "code" },
        ],
    },
    {
        label: "Отчеты и журналы",
        items: [
            { label: "Отчеты", value: "reports", icon: "assessment" },
            { label: "Служебные", value: "official", icon: "work" },
            { label: "Подписки", value: "subscriptions", icon: "subscriptions" },
            { label: "Журнал PMS", value: "message_logs", icon: "receipt_long" },
        ],
    },
];

// Права доступа по типам пользователей
export const USER_PERMISSIONS = {
    admin: [
        "hotels",
        "companies",
        "places_sales",
        "users",
        "access_logs",
        "configurations",
        "payment_methods",
        "interface_types",
        "interfaces",
        "room_types",
        "room_quotas",
        "rates",
        "room_rates",
        "price_periods",
        "cancellation_policy",
        "refund",
        "service_categories",
        "services",
        "room_feature_categories",
        "room_features",
        "reservations",
        "reservations_asu",
        "banArrivals",
        "period_residence",
        "price_explanation",
        "purchased_services",
        "promo",
        "market_groups",
        "market_codes",
        "reports",
        "official",
        "subscriptions",
        "message_logs",
    ],
    manager: [
        "hotels",
        "room_types",
        "operators",
        "room_quotas",
        "rates",
        "cancellation_policy",
        "refund",
        "service_categories",
        "services",
        "room_feature_categories",
        "room_features",
        "room_rates",
        "price_periods",
        "reservations",
        "reservations_asu",
        "banArrivals",
        "period_residence",
        "price_explanation",
        "purchased_services",
        "promo",
        "reports",
        "official",
        "subscriptions",
        "market_groups",
        "market_codes",
        "message_logs",
    ],
    operator: [
        "room_quotas",
        "rates",
        "cancellation_policy",
        "refund",
        "service_categories",
        "services",
        "room_feature_categories",
        "room_features",
        "room_rates",
        "price_periods",
        "reservations",
        "reservations_asu",
        "banArrivals",
        "period_residence",
        "price_explanation",
        "purchased_services",
        "promo",
        "reports",
        "official",
        "subscriptions",
    ],
    manager_export: [
        "hotels",
        "reports",
        "reservations",
    ],
};

// Старая структура меню (для обратной совместимости)
const operatorMenu = {
    "Квоты номеров": "room_quotas",
    Тарифы: "rates",
    "Правила отмены": "cancellation_policy",
    "Возвраты ДС": "refund",
    "Категории услуг": "service_categories",
    Услуги: "services",
    "Категории удобств": "room_feature_categories",
    Удобства: "room_features",
    "Стоимость проживания": "room_rates",
    "Уровни цен": "price_periods",
    Заявки: "reservations",
    "Заявки АСУ": "reservations_asu",
    "Запреты выезда": "banArrivals",
    "Срок проживания": "period_residence",
    "Толкование цен": "price_explanation",
    "Купленные услуги": "purchased_services",
    Промокоды: "promo",
    Отчеты: "reports",
    Служебные: "official",
    Подписки: "subscriptions",
};

const menu = {
    admin: {
        Компании: "companies",
        "Точки продаж": "places_sales",
        Отели: "hotels",
        Пользователи: "users",
        "Журнал доступов": "access_logs",
        "Способы оплаты": "payment_methods",
        Конфигурация: "configurations",
        "Типы интерфейсов": "interface_types",
        Интерфейсы: "interfaces",
    },
    operator: {
        ...operatorMenu,
    },
    manager: {
        "Мои Отели": "hotels",
        "Категории номеров": "room_types",
        Операторы: "operators",
        ...operatorMenu,
        "Торговые группы": "market_groups",
        "Торговые коды": "market_codes",
        "Журнал PMS": "message_logs",
    },
    manager_export: {
        "Мои Отели": "hotels",
        Отчеты: "reports",
        Заявки: "reservations",
    },
};

export const getMenuLegacy = (userType) =>
    userType && menu[userType] ? menu[userType] : {};

// Функция getMenu для authorized.jsx (возвращает объект)
export const getMenu = (userType) => {
    return getMenuLegacy(userType);
};

// Функция getMenuBlocks для UserMenu.jsx (возвращает массив блоков)
export const getMenuBlocks = (userType) => {
    const userPermissions = USER_PERMISSIONS[userType];
    if (!userPermissions) return [];
    
    const result = [];
    
    MENU_BLOCKS.forEach((block) => {
        const items = block.items.filter((item) => 
            userPermissions.includes(item.value)
        );
        
        if (items.length > 0) {
            result.push({
                label: block.label,
                items: items,
            });
        }
    });
    
    return result;
};